/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Module: Saamlawnese
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.saaml.js
Source: slb_src/slices/saaml/
Build: slb_build/build_saaml.mjs
Built: 2026-09-19 16:53:58.761Z
Content-SHA256: 8f494d7175bd1613db0282a3e9a32bbc2619e21a7e5c5f67f71eaedabd8cba8e
Content-SHA256-12: 8f494d7175bd
*/

/* SLB Saamlawnese Dictionary + Admin Tools (lazy module)
   - User: Dictionary search + token detail
   - Admin: init/diag + master upsert + bulk upsert + corrections workflow
   Notes:
   - Uses SLB_APP.rpc(action,args) (returns msg.data)
   - Hooks into window.SLB.features.onOpen(tab)
*/
(function(){
  "use strict";

  if(window.__SLB_SAAML_LOADED__) return;
  window.__SLB_SAAML_LOADED__ = true;

  function $(id){ return document.getElementById(id); }
  function show(el){ if(el) el.classList.remove("hidden"); }
  function hide(el){ if(el) el.classList.add("hidden"); }
  function setText(el, s){ if(el) el.textContent = (s==null?"":String(s)); }

  function esc(s){
    s = (s==null?"":String(s));
    return s.replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]);
    });
  }

  function toast(kind, msg){
    try{
      if(window.SLB_APP && typeof window.SLB_APP.toast === "function"){
        window.SLB_APP.toast(kind, msg);
        return;
      }
    }catch(_e){}
    try{ console[(kind==="err"?"error":"log")]("[SAAML]", msg); }catch(_e2){}
  }

  async function rpc(action, args){
    if(!window.SLB_APP || typeof window.SLB_APP.rpc !== "function"){
      throw new Error("SLB_APP.rpc not ready");
    }
    return await window.SLB_APP.rpc(action, args || {});
  }

  function injectCssOnce(){
    if(document.getElementById("slbSaamlCss")) return;
    var css = `
      .slbSaamlTable{width:100%;}
      .slbSaamlRowBtn{cursor:pointer;color:#ef5e14;font-weight:900;text-decoration:underline;}
      .slbSaamlMono{font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;}
      .slbSaamlDetailBox{padding:10px 12px;border:1px solid rgba(0,0,0,0.10);border-radius:12px;background:rgba(239,94,20,0.06);white-space:pre-wrap;}
      #slbSaamlCorrTableWrap .tableWrap{max-height:min(520px, 70vh);}
      #slbSaamlCorrTableWrap tbody tr.slbSaamlMissing{background:rgba(239,94,20,0.10)!important;}
      #slbSaamlCorrTableWrap tbody tr.slbSaamlChanged{outline:2px solid rgba(239,94,20,0.35);}
      .slbSaamlTiny{font-size:12px;opacity:.85;}
    `;
    var st = document.createElement("style");
    st.id = "slbSaamlCss";
    st.textContent = css;
    document.head.appendChild(st);
  }

  // -----------------------
  // User dictionary
  // -----------------------
  var dictBooted = false;

  function dictStatus(msg){ setText($("slbSaamlStatus"), msg||""); }

  function normalizeChineseDisplay_(r){
    try{
      if(Array.isArray(r.chinese_chars)) return r.chinese_chars.join("");
      if(Array.isArray(r.chars)) return r.chars.join("");
      if(r.charsJoined) return String(r.charsJoined);
      if(r.ch) return String(r.ch);
      return "";
    }catch(_e){ return ""; }
  }

  function renderResults(res){
    var wrap = $("slbSaamlResults");
    if(!wrap) return;

    var rows = (res && (res.results || res.rows)) ? (res.results || res.rows) : [];
    if(!Array.isArray(rows)) rows = [];
    if(!rows.length){
      wrap.innerHTML = `<div class="note">No result.</div>`;
      return;
    }

    var showEnglish = rows.some(function(r){ return !!(r && r.english); });
    var showAudio = rows.some(function(r){ return !!(r && r.hasAudio); });

    var head = `
      <div class="tableWrap">
        <table class="slbSaamlTable">
          <thead>
            <tr>
              <th style="width:170px;">Token</th>
              <th style="width:220px;">Display</th>
              <th>Chinese</th>
              ${showEnglish ? `<th style="width:280px;">English</th>` : ``}
              ${showAudio ? `<th style="width:110px;">Audio</th>` : ``}
              <th style="width:90px;" class="noclick">Open</th>
            </tr>
          </thead>
          <tbody>
    `;

    var body = rows.map(function(r){
      r = r || {};
      var token = esc(r.token||"");
      var display = esc(r.display||"");
      var chinese = esc(normalizeChineseDisplay_(r));
      var english = esc(r.english||"");
      var audio = (r.hasAudio && r.audioUrl) ? (`<span class="slbSaamlRowBtn" data-play="1" data-url="${esc(r.audioUrl)}" data-token="${token}">Play</span>`) : "";
      return `
        <tr>
          <td class="slbSaamlMono">${token}</td>
          <td>${display}</td>
          <td>${chinese}</td>
          ${showEnglish ? `<td>${english}</td>` : ``}
          ${showAudio ? `<td>${audio}</td>` : ``}
          <td><span class="slbSaamlRowBtn" data-token="${token}">Open</span></td>
        </tr>
      `;
    }).join("");

    wrap.innerHTML = head + body + "</tbody></table></div>";
  }

  function openDetailFold(){
    var body = $("slbSaamlDetailFoldBody");
    var btn = $("slbSaamlDetailFoldBtn");
    if(body && body.classList.contains("hidden")){
      body.classList.remove("hidden");
      if(btn) btn.textContent = "Close";
    }
  }

  function closeDetailFold(){
    var body = $("slbSaamlDetailFoldBody");
    var btn = $("slbSaamlDetailFoldBtn");
    if(body && !body.classList.contains("hidden")){
      body.classList.add("hidden");
      if(btn) btn.textContent = "Open";
    }
  }

  async function loadTokenDetail(token){
    injectCssOnce();
    var out = $("slbSaamlDetail");
    if(!out) return;
    setText(out, "Loading…");
    openDetailFold();

    try{
      var res = await rpc("saamlDictGetToken", { token: token });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Failed");

      var lines = [];
      lines.push("Token: " + (res.token || token));
      if(res.display) lines.push("Display: " + res.display);
      if(res.english) lines.push("English: " + res.english);
      if(res.chinese_explain) lines.push("Chinese explain: " + res.chinese_explain);
      if(res.tags) lines.push("Tags: " + res.tags);
      if(res.hasAudio) lines.push("Audio: Yes");

      var chars = Array.isArray(res.chinese_chars) ? res.chinese_chars : [];
      if(chars.length) lines.push("\nChars:\n" + chars.join(""));

      var audioHtml = (res.hasAudio && res.audioUrl) ? (`<div style="margin-top:8px;"><audio controls preload="none" style="width:100%;" src="${esc(res.audioUrl)}"></audio></div>`) : "";
      out.innerHTML = `<div class="slbSaamlDetailBox slbSaamlMono">${esc(lines.join("\n"))}</div>` + audioHtml;
    }catch(e){
      var msg = (e && e.message) ? e.message : String(e||"Error");
      out.innerHTML = `<div class="err">${esc(msg)}</div>`;
      toast("err", msg);
    }
  }

  async function doSearch(){
    injectCssOnce();
    var q = $("slbSaamlQ");
    var mode = $("slbSaamlMode");
    var exact = $("slbSaamlExact");
    var hasAudio = $("slbSaamlHasAudio");
    var btn = $("slbSaamlSearchBtn");
    if(!q || !mode || !btn) return;

    var qv = (q.value||"").trim();
    if(!qv){
      dictStatus("Type something to search.");
      renderResults({results:[]});
      return;
    }

    btn.disabled = true;
    dictStatus("Searching…");

    try{
      var res = await rpc("saamlDictSearch", {
        q: qv,
        mode: mode.value,
        exactOnly: !!(exact && exact.checked),
        hasAudioOnly: !!(hasAudio && hasAudio.checked),
        limit: 120
      });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Search failed");
      var rows = Array.isArray(res.results) ? res.results : [];
      dictStatus(rows.length + " result(s)");
      renderResults(res);
      closeDetailFold();
      setText($("slbSaamlDetail"), "");
    }catch(e){
      var msg = (e && e.message) ? e.message : String(e||"Error");
      dictStatus("Error");
      renderResults({results:[]});
      toast("err", msg);
    }finally{
      btn.disabled = false;
    }
  }

  function initDict(){
    if(dictBooted) return;
    dictBooted = true;
    injectCssOnce();

    var q = $("slbSaamlQ");
    var btn = $("slbSaamlSearchBtn");
    var wrap = $("slbSaamlResults");
    var foldBtn = $("slbSaamlDetailFoldBtn");

    if(btn) btn.addEventListener("click", doSearch);
    if(q) q.addEventListener("keydown", function(e){
      if(e.key === "Enter"){ e.preventDefault(); doSearch(); }
    });
    
var audioEl = new Audio();
audioEl.preload = "none";

function playUrl_(url){
  url = String(url||"").trim();
  if(!url) return;
  try{ audioEl.pause(); }catch(_e){}
  try{
    audioEl.src = url;
    audioEl.play();
  }catch(_e2){}
}

if(wrap) wrap.addEventListener("click", function(e){
  var pb = e.target && e.target.closest ? e.target.closest("[data-play=\"1\"]") : null;
  if(pb){
    e.preventDefault();
    e.stopPropagation();
    playUrl_(String(pb.getAttribute("data-url")||""));
    return;
  }
  var t = e.target && e.target.closest ? e.target.closest("[data-token]") : null;
  if(!t) return;
  var token = t.getAttribute("data-token") || "";
  if(token) loadTokenDetail(token);
});
if(foldBtn) foldBtn.addEventListener("click", function(){
      var body = $("slbSaamlDetailFoldBody");
      if(!body) return;
      var isOpen = !body.classList.contains("hidden");
      if(isOpen){ closeDetailFold(); } else { openDetailFold(); }
    });

    dictStatus("Ready.");
  }

  // -----------------------
  // Admin tools
  // -----------------------
  var adminBooted = false;
  var adminTab = "master";
  var corrState = { rows: [], text: "" };

  function adminMsg(ok, err){
    var e = $("slbSaamlAdminErr");
    var o = $("slbSaamlAdminOk");
    if(ok){ hide(e); show(o); setText(o, ok); }
    else if(err){ hide(o); show(e); setText(e, err); }
    else { hide(e); hide(o); }
  }

  function adminSetTab(tab){
    adminTab = (tab === "corrections") ? "corrections"
            : (tab === "meta_audio") ? "meta_audio"
            : (tab === "scripture") ? "scripture"
            : "master";

    var masterWrap = $("slbSaamlAdminMasterWrap");
    var corrWrap   = $("slbSaamlAdminCorrectionsWrap");
    var metaWrap   = $("slbSaamlAdminMetaAudioWrap");
    var scrWrap    = $("slbSaamlAdminScriptureWrap");

    if(adminTab === "master"){
      show(masterWrap); hide(corrWrap); hide(metaWrap); hide(scrWrap);
    }else if(adminTab === "corrections"){
      hide(masterWrap); show(corrWrap); hide(metaWrap); hide(scrWrap);
    }else if(adminTab === "scripture"){
      hide(masterWrap); hide(corrWrap); hide(metaWrap); show(scrWrap);
    }else{
      hide(masterWrap); hide(corrWrap); show(metaWrap); hide(scrWrap);
    }
  }

  async function adminDiag(){
    adminMsg("", "");
    var out = $("slbSaamlDiagOut");
    if(out) out.textContent = "Loading…";
    try{
      var res = await rpc("adminSaamlDiag", {});
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Diag failed");
      if(out){
        out.innerHTML = "";
        var lines = [];
        if(res.saamlSpreadsheetName) lines.push("Spreadsheet: " + res.saamlSpreadsheetName);
        lines.push("Spreadsheet ID: " + (res.saamlSpreadsheetId || "—"));
        if(res.backupSpreadsheetIds && res.backupSpreadsheetIds.length){
          lines.push("Backup IDs: " + res.backupSpreadsheetIds.length);
        }
        lines.push("MASTER rows: " + (res.masterRows || 0));
        lines.push("TOKEN_META rows: " + (res.tokenMetaRows || 0));
        lines.push("TOKEN_INDEX rows: " + (res.tokenIndexRows || 0));
        lines.push("AUDIO rows: " + (res.audioRows || 0));
        var block = document.createElement("div");
        block.style.whiteSpace = "pre-wrap";
        block.textContent = lines.join("\n");
        out.appendChild(block);
        if(res.saamlSpreadsheetUrl){
          var link = document.createElement("a");
          link.href = res.saamlSpreadsheetUrl;
          link.target = "_blank";
          link.rel = "noopener";
          link.textContent = "Open Spreadsheet";
          var lwrap = document.createElement("div");
          lwrap.style.marginTop = "6px";
          lwrap.appendChild(link);
          out.appendChild(lwrap);
        }
      }
      adminMsg("Diag ok.", "");
    }catch(e){
      var msg = (e && e.message) ? e.message : String(e||"Error");
      if(out) out.textContent = "";
      adminMsg("", msg);
      toast("err", msg);
    }
  }

  async function adminInit(){
    adminMsg("", "");
    try{
      var res = await rpc("adminSaamlInit", {});
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Init failed");
      adminMsg("Init ok. Spreadsheet ID: " + (res.saamlSpreadsheetId || "—"), "");
      await adminDiag();
    }catch(e){
      var msg = (e && e.message) ? e.message : String(e||"Error");
      adminMsg("", msg);
      toast("err", msg);
    }
  }

  async function adminUpsert(){
    adminMsg("", "");
    var chEl = $("slbSaamlChar");
    var tokEl = $("slbSaamlToken");
    var ch = chEl ? String(chEl.value||"").trim() : "";
    var token = tokEl ? String(tokEl.value||"").trim() : "";
    if(!ch || ch.length !== 1){ adminMsg("", "Please input exactly 1 Chinese character."); return; }
    if(!token){ adminMsg("", "Please input token."); return; }

    try{
      var res = await rpc("adminSaamlCharUpsert", { char: ch, token: token });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Save failed");
      adminMsg("Saved: " + ch + " → " + (res.token || token), "");
      await adminDiag();
    }catch(e){
      var msg = (e && e.message) ? e.message : String(e||"Error");
      adminMsg("", msg);
      toast("err", msg);
    }
  }

  function parseBulk_(raw){
    raw = String(raw||"");
    var lines = raw.split(/\r?\n/);
    var out = [];
    for(var i=0;i<lines.length;i++){
      var line = String(lines[i]||"").trim();
      if(!line) continue;
      // allow comma/tab/space
      var parts = line.split(/[\t,]/);
      if(parts.length === 1){
        // try first char + rest
        var c = line.trim().charAt(0);
        var rest = line.trim().slice(1).trim();
        if(c && rest) out.push([c, rest]);
        continue;
      }
      var c2 = String(parts[0]||"").trim();
      var t2 = String(parts.slice(1).join(" ")||"").trim();
      if(c2.length !== 1) c2 = c2.charAt(0);
      if(c2 && t2) out.push([c2, t2]);
    }
    // unique by char (keep last)
    var seen = {};
    var uniq = [];
    for(var j=out.length-1;j>=0;j--){
      var ch = out[j][0];
      if(!seen[ch]){ seen[ch] = 1; uniq.push(out[j]); }
    }
    uniq.reverse();
    if(uniq.length > 2000) uniq = uniq.slice(0,2000);
    return uniq;
  }

  async function adminBulkApply(){
    adminMsg("", "");
    var ta = $("slbSaamlBulkText");
    var out = $("slbSaamlBulkOut");
    if(out) out.textContent = "";
    var items = parseBulk_(ta ? ta.value : "");
    if(!items.length){
      adminMsg("", "No valid lines found.");
      return;
    }
    try{
      if(out) out.textContent = "Saving…";
      var res = await rpc("adminSaamlCharBulkUpsert", { items: items });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Bulk save failed");
      var msg = "Saved " + (res.savedCount||0) + " char(s). Tokens touched: " + (res.tokensTouched||0);
      if(out) out.textContent = msg;
      adminMsg("Bulk saved.", "");
      await adminDiag();
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      if(out) out.textContent = "";
      adminMsg("", m);
      toast("err", m);
    }
  }

  async function adminLookupToken(){
    adminMsg("", "");
    var t = $("slbSaamlTokLookup");
    var out = $("slbSaamlLookupOut");
    var token = t ? String(t.value||"").trim() : "";
    if(!token){ setText(out, ""); adminMsg("", "Please input a token."); return; }
    try{
      setText(out, "Loading…");
      var res = await rpc("saamlDictGetToken", { token: token });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Not found");
      var lines = [];
      lines.push("Token: " + (res.token||token));
      if(res.display) lines.push("Display: " + res.display);
      if(res.english) lines.push("English: " + res.english);
      if(res.chinese_explain) lines.push("Chinese explain: " + res.chinese_explain);
      if(res.tags) lines.push("Tags: " + res.tags);
      if(Array.isArray(res.chinese_chars) && res.chinese_chars.length) lines.push("Chars: " + res.chinese_chars.join(""));
      setText(out, lines.join("\n"));
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      setText(out, "");
      adminMsg("", m);
      toast("err", m);
    }
  }

  async function adminLookupChar(){
    adminMsg("", "");
    var c = $("slbSaamlCharLookup");
    var out = $("slbSaamlLookupOut");
    var ch = c ? String(c.value||"").trim() : "";
    if(!ch || ch.length !== 1){ setText(out, ""); adminMsg("", "Please input exactly 1 Chinese character."); return; }
    try{
      setText(out, "Loading…");
      var res = await rpc("adminSaamlCharLookupBatch", { chars: [ch] });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Lookup failed");
      var tok = (res.map && (ch in res.map)) ? (res.map[ch]||"") : "";
      setText(out, ch + " → " + (tok || "(missing)"));
      // convenience: preload quick upsert fields
      if($("slbSaamlChar")) $("slbSaamlChar").value = ch;
      if($("slbSaamlToken") && tok) $("slbSaamlToken").value = tok;
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      setText(out, "");
      adminMsg("", m);
      toast("err", m);
    }
  }


  // Import MASTER.csv (replace) - chunked upload
  function stripQuotes_(s){
    s = String(s||"").trim();
    if(s.length >= 2 && s.charAt(0) === '"' && s.charAt(s.length-1) === '"'){
      s = s.slice(1, -1).replace(/""/g, '"');
    }
    return s.trim();
  }
  function splitCsvLine2_(line){
    line = String(line||"");
    // Split by comma not inside quotes (simple CSV)
    var parts = line.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/);
    if(parts.length < 2){
      if(line.indexOf("\t") >= 0) parts = line.split("\t");
      else parts = line.split(/\s+/);
    }
    var a = stripQuotes_(parts[0]||"");
    var b = stripQuotes_(parts[1]||"");
    return [a,b];
  }
  function parseMasterCsv2col_(text){
    var s = String(text||"");
    // UTF-8 BOM
    if(s.charCodeAt(0) === 0xFEFF) s = s.slice(1);
    s = s.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    var lines = s.split("\n");
    var rows = [];
    for(var i=0;i<lines.length;i++){
      var ln = String(lines[i]||"").trim();
      if(!ln) continue;
      if(ln.charAt(0) === "#") continue;
      var ab = splitCsvLine2_(ln);
      var ch = (ab[0]||"").trim();
      var tok = (ab[1]||"").trim();
      if(!ch || !tok) continue;
      if(ch.toLowerCase() === "chinese_char") continue;
      if(tok.toLowerCase() === "token") continue;
      // Keep exactly first char only
      if(ch.length !== 1) ch = ch.charAt(0);
      if(!ch || ch.length !== 1) continue;
      rows.push([ch, tok]);
    }
    return rows;
  }
  async function readFileText_(file){
    return await new Promise(function(resolve, reject){
      try{
        var fr = new FileReader();
        fr.onload = function(){ resolve(String(fr.result||"")); };
        fr.onerror = function(){ reject(new Error("File read failed")); };
        fr.readAsText(file);
      }catch(e){ reject(e); }
    });
  }

  async function adminImportMasterCsv(){
    adminMsg("", "");
    var fileInp = $("slbSaamlImportFile");
    var btn = $("slbSaamlImportBtn");
    var out = $("slbSaamlImportOut");
    if(out) setText(out, "");

    var f = null;
    try{ f = fileInp && fileInp.files && fileInp.files[0] ? fileInp.files[0] : null; }catch(_e){}
    if(!f){
      toast("err", "Please choose your saamlawnese_master.csv file first.");
      return;
    }

    try{
      if(btn) btn.disabled = true;
      if(out) setText(out, "Reading file…");
      var text = await readFileText_(f);
      var rows = parseMasterCsv2col_(text);
      if(!rows.length){
        if(out) setText(out, "");
        toast("err", "No valid rows found in CSV.");
        return;
      }

      if(!confirm("Import " + rows.length + " rows and REPLACE the server MASTER? This will rebuild TOKEN_INDEX automatically.")) return;

      if(out) setText(out, "Init import…");
      var init = await rpc("adminSaamlImportMasterCsvInit", { fileName: f.name, totalRows: rows.length });
      if(!init || !init.ok) throw new Error((init && (init.err||init.error)) || "Init failed");
      var importId = init.importId;

      var chunkSize = 200;
      var imported = 0;
      for(var i=0;i<rows.length;i+=chunkSize){
        var sub = rows.slice(i, i+chunkSize);
        if(out) setText(out, "Uploading… " + Math.min(i, rows.length) + "/" + rows.length);
        var res = await rpc("adminSaamlImportMasterCsvChunk", { importId: importId, rows: sub, chunkIndex: Math.floor(i/chunkSize) });
        if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Chunk upload failed");
        imported = res.importedTotal != null ? res.importedTotal : (i + sub.length);
        if(out) setText(out, "Uploading… " + imported + "/" + rows.length);
      }

      if(out) setText(out, "Finalizing (dedupe + rebuild index)…");
      var fin = await rpc("adminSaamlImportMasterCsvFinalize", { importId: importId });
      if(!fin || !fin.ok) throw new Error((fin && (fin.err||fin.error)) || "Finalize failed");

      var msg = [];
      msg.push("DONE");
      msg.push("MASTER rows: " + (fin.masterRows||0));
      msg.push("TOKEN_INDEX tokens: " + (fin.tokenIndexRows||0));
      if(fin.finalizedAt) msg.push("Finalized at: " + fin.finalizedAt);
      if(out) setText(out, msg.join("\n"));

      toast("ok", "MASTER imported.");
      try{ await adminDiag(); }catch(_e2){}
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      if(out) setText(out, "");
      adminMsg("", m);
      toast("err", m);
    }finally{
      if(btn) btn.disabled = false;
    }
  }

  async function maintCreateNewDb(){
    var out = $("slbSaamlMaintOut");
    setText(out, "");
    if(!confirm("Create a NEW Saamlawnese DB Spreadsheet? This is safe (old DB is kept as backup), but new DB will be empty.")) return;
    try{
      setText(out, "Creating new spreadsheet…");
      var res = await rpc("adminSaamlCreateNewDb", {});
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Create failed");
      setText(out, "Created. New ID: " + (res.newId||"—") + (res.oldId ? " | old backed up" : ""));
      await adminDiag();
      toast("ok", "New DB created.");
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      setText(out, "");
      toast("err", m);
    }
  }

  async function maintRebuildIndex(){
    var out = $("slbSaamlMaintOut");
    setText(out, "");
    if(!confirm("Rebuild TOKEN_INDEX from MASTER? This can take a bit if the DB is large.")) return;
    try{
      setText(out, "Rebuilding index…");
      var res = await rpc("adminSaamlRebuildTokenIndexAll", {});
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Rebuild failed");
      setText(out, "Index rebuilt. Tokens: " + (res.tokens||0));
      await adminDiag();
      toast("ok", "Index rebuilt.");
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      setText(out, "");
      toast("err", m);
    }
  }

  async function fetchAllPages_(action, limit, outEl){
    var offset = 0;
    limit = Math.max(50, Math.min(500, Number(limit||500)));
    var headers = null;
    var rows = [];
    var total = 0;
    for(var guard=0; guard<9999; guard++){
      var res = await rpc(action, { offset: offset, limit: limit });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || (action + " failed"));
      if(!headers) headers = res.headers || [];
      total = res.total || total;
      if(res.rows && res.rows.length){
        for(var i=0;i<res.rows.length;i++) rows.push(res.rows[i]);
        offset = res.nextOffset || (offset + res.rows.length);
      }else{
        offset = res.nextOffset || offset;
      }
      if(outEl) setText(outEl, "Exporting… " + offset + "/" + (total || "?"));
      if(res.done) break;
      if(!res.rows || !res.rows.length) break;
    }
    return { headers: headers || [], rows: rows, total: total };
  }

  async function exportSheetCsv_(action, filename){
    var out = $("slbSaamlMaintOut");
    try{
      setText(out, "Starting export…");
      var got = await fetchAllPages_(action, 500, out);
      downloadCsv_(filename, got.headers, got.rows);
      setText(out, "Downloaded: " + filename + " (rows: " + got.rows.length + ")");
      toast("ok", "Exported.");
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      setText(out, "");
      toast("err", m);
    }
  }

  async function exportMasterJson_(){
    var out = $("slbSaamlMaintOut");
    try{
      setText(out, "Starting export…");
      var got = await fetchAllPages_("adminSaamlExportMasterPage", 500, out);
      var map = {};
      for(var i=0;i<got.rows.length;i++){
        var r = got.rows[i];
        var ch = r && r[0] ? String(r[0]).trim() : "";
        var tok = r && r[1] ? String(r[1]).trim() : "";
        if(ch && ch.length===1 && tok) map[ch] = tok;
      }
      var txt = JSON.stringify(map, null, 2);
      downloadText_("saamlawnese_master.json", txt);
      setText(out, "Downloaded: saamlawnese_master.json (entries: " + Object.keys(map).length + ")");
      toast("ok", "Exported.");
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      setText(out, "");
      toast("err", m);
    }
  }

  function countCjkChars_(txt){
    txt = String(txt||"");
    var m = txt.match(/[\u3400-\u9FFF]/g);
    if(!m || !m.length) return { counts:{}, chars:[] };
    var counts = {};
    for(var i=0;i<m.length;i++){
      var c = m[i];
      counts[c] = (counts[c]||0) + 1;
    }
    var chars = Object.keys(counts);
    chars.sort(function(a,b){ return (counts[b]-counts[a]) || a.localeCompare(b); });
    return { counts:counts, chars:chars };
  }

  function renderCorrectionsTable_(counts, lookup){
    var wrap = $("slbSaamlCorrTableWrap");
    if(!wrap) return;
    var chars = Object.keys(counts||{});
    chars.sort(function(a,b){ return (counts[b]-counts[a]) || a.localeCompare(b); });

    var map = (lookup && lookup.map) ? lookup.map : {};
    var missing = (lookup && Array.isArray(lookup.missing)) ? lookup.missing : [];
    var missSet = {};
    for(var i=0;i<missing.length;i++) missSet[missing[i]] = 1;

    var html = `
      <div class="tableWrap">
        <table class="slbSaamlTable">
          <thead>
            <tr>
              <th style="width:70px;">Char</th>
              <th style="width:80px;">Count</th>
              <th style="width:180px;">Current</th>
              <th style="width:220px;" class="noclick">New token</th>
              <th style="width:120px;">Status</th>
            </tr>
          </thead>
          <tbody>
    `;

    for(var j=0;j<chars.length;j++){
      var ch = chars[j];
      var cnt = counts[ch]||0;
      var oldTok = (map && (ch in map)) ? String(map[ch]||"") : "";
      var isMissing = !oldTok || !!missSet[ch];
      var cls = isMissing ? "slbSaamlMissing" : "";
      var status = isMissing ? "missing" : "ok";
      html += `
        <tr class="${cls}" data-ch="${esc(ch)}" data-old="${esc(oldTok)}">
          <td class="slbSaamlMono">${esc(ch)}</td>
          <td>${cnt}</td>
          <td class="slbSaamlMono">${esc(oldTok)}</td>
          <td><input class="inp slbSaamlCorrInp" value="${esc(oldTok)}" placeholder="Token" /></td>
          <td class="slbSaamlTiny slbSaamlCorrStat">${status}</td>
        </tr>
      `;
    }

    html += "</tbody></table></div>";
    wrap.innerHTML = html;
  }

  function correctionsChangedCount_(){
    var wrap = $("slbSaamlCorrTableWrap");
    if(!wrap) return 0;
    var rows = wrap.querySelectorAll("tbody tr.slbSaamlChanged");
    return rows ? rows.length : 0;
  }

  async function correctionsAnalyze(){
    adminMsg("", "");
    injectCssOnce();
    var ta = $("slbSaamlCorrText");
    var summary = $("slbSaamlCorrSummary");
    var applyBtn = $("slbSaamlCorrApplyBtn");
    if(applyBtn) applyBtn.disabled = true;
    setText(summary, "");
    if(!ta) return;

    var text = String(ta.value||"");
    corrState.text = text;
    var cc = countCjkChars_(text);
    if(!cc.chars.length){
      setText(summary, "No Chinese characters found.");
      $("slbSaamlCorrTableWrap").innerHTML = "<div class=\"note\">Nothing to show.</div>";
      return;
    }

    try{
      setText(summary, "Looking up " + cc.chars.length + " char(s)…");
      var res = await rpc("adminSaamlCharLookupBatch", { chars: cc.chars });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Lookup failed");
      corrState.rows = cc.chars.slice(0);
      renderCorrectionsTable_(cc.counts, res);
      var miss = (Array.isArray(res.missing) ? res.missing.length : 0);
      setText(summary, "Unique chars: " + cc.chars.length + " | missing: " + miss + " | edit tokens then Apply Changes");
      if(applyBtn) applyBtn.disabled = false;
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      setText(summary, "");
      $("slbSaamlCorrTableWrap").innerHTML = "";
      adminMsg("", m);
      toast("err", m);
    }
  }

  function onCorrectionsInput_(e){
    var inp = e.target;
    if(!inp || !inp.classList || !inp.classList.contains("slbSaamlCorrInp")) return;
    var tr = inp.closest ? inp.closest("tr") : null;
    if(!tr) return;
    var oldTok = String(tr.getAttribute("data-old") || "");
    var newTok = String(inp.value||"").trim();
    var stat = tr.querySelector(".slbSaamlCorrStat");

    if(!newTok){
      tr.classList.remove("slbSaamlChanged");
      if(stat) stat.textContent = "blank";
      return;
    }
    if(newTok !== oldTok){
      tr.classList.add("slbSaamlChanged");
      if(stat) stat.textContent = "changed";
    }else{
      tr.classList.remove("slbSaamlChanged");
      if(stat) stat.textContent = (oldTok ? "ok" : "missing");
    }

    var summary = $("slbSaamlCorrSummary");
    if(summary){
      var changed = correctionsChangedCount_();
      if(changed) summary.textContent = summary.textContent.replace(/\s\|\schanged:\s\d+\s*$/i, "") + " | changed: " + changed;
    }
  }

  async function correctionsApply(){
    adminMsg("", "");
    var wrap = $("slbSaamlCorrTableWrap");
    var summary = $("slbSaamlCorrSummary");
    if(!wrap) return;
    var rows = wrap.querySelectorAll("tbody tr");
    if(!rows || !rows.length){ adminMsg("", "Nothing to apply."); return; }

    var items = [];
    for(var i=0;i<rows.length;i++){
      var tr = rows[i];
      var ch = String(tr.getAttribute("data-ch") || "");
      var oldTok = String(tr.getAttribute("data-old") || "");
      var inp = tr.querySelector("input.slbSaamlCorrInp");
      var newTok = inp ? String(inp.value||"").trim() : "";
      if(!ch || ch.length !== 1) continue;
      if(!newTok) continue;
      if(newTok === oldTok) continue;
      items.push([ch, newTok]);
      if(items.length >= 2000) break;
    }

    if(!items.length){
      adminMsg("", "No changes detected.");
      return;
    }

    try{
      if(summary) summary.textContent = "Saving " + items.length + " change(s)…";
      var res = await rpc("adminSaamlCharBulkUpsert", { items: items });
      if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Apply failed");
      adminMsg("Applied changes.", "");
      await adminDiag();
      // re-run analyze to refresh current tokens
      await correctionsAnalyze();
    }catch(e){
      var m = (e && e.message) ? e.message : String(e||"Error");
      adminMsg("", m);
      toast("err", m);
      if(summary) summary.textContent = "";
    }
  }

  
// -----------------------
// Scripture Tool (Admin)
// -----------------------
var SCRIPT_PUNCT_MAP = {
  "，": ",", "。": ".", "、": ",", "；": ";", "：": ":", "？": "?", "！": "!",
  "「": "\"", "」": "\"", "『": "\"", "』": "\"", "（": "(", "）": ")", "【": "[", "】": "]",
  "《": "<", "》": ">", "〈": "<", "〉": ">", "…": "..."
};

function isCjkChar_(ch){
  if(!ch) return false;
  var code = ch.charCodeAt(0);
  return (code >= 0x4E00 && code <= 0x9FFF)   // CJK Unified
      || (code >= 0x3400 && code <= 0x4DBF)   // Ext A
      || (code >= 0xF900 && code <= 0xFAFF);  // Compatibility
}

function collectCharCounts_(text){
  var counts = Object.create(null);
  for(var i=0;i<text.length;i++){
    var ch = text.charAt(i);
    if(!isCjkChar_(ch)) continue;
    counts[ch] = (counts[ch] || 0) + 1;
  }
  var chars = Object.keys(counts);
  return { counts: counts, chars: chars };
}

async function lookupCharsMap_(chars){
  // Chunk calls to keep JSONP small
  var map = Object.create(null);
  var missing = [];
  var chunkSize = 400;
  for(var i=0;i<chars.length;i+=chunkSize){
    var chunk = chars.slice(i, i+chunkSize);
    var res = await rpc("adminSaamlCharLookupBatch", { chars: chunk });
    if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Lookup failed");
    var m = res.map || {};
    for(var k in m){
      if(Object.prototype.hasOwnProperty.call(m,k)) map[k] = m[k];
    }
    var miss = res.missing || [];
    for(var j=0;j<miss.length;j++) missing.push(miss[j]);
  }
  // unique missing
  var seen = Object.create(null);
  var uniq = [];
  for(var z=0;z<missing.length;z++){
    var ch2 = missing[z];
    if(!seen[ch2]){ seen[ch2]=1; uniq.push(ch2); }
  }
  return { map: map, missing: uniq };
}

function capTok_(tok){
  tok = String(tok||"");
  if(!tok) return "";
  if(tok.charAt(0) === "[") return tok;
  return tok.charAt(0).toUpperCase() + tok.slice(1);
}

function normalizePunct_(ch){
  return SCRIPT_PUNCT_MAP[ch] || ch;
}

function transliterateLine_(line, map){
  var out = "";
  for(var i=0;i<line.length;i++){
    var ch = line.charAt(i);

    if(isCjkChar_(ch)){
      var tok = map && map[ch] ? String(map[ch]) : "";
      if(tok){
        out += capTok_(tok) + " ";
      }else{
        out += "[" + ch + "] ";
      }
      continue;
    }

    // Chinese punctuation map
    if(SCRIPT_PUNCT_MAP[ch]){
      out = out.replace(/\s+$/,"");
      out += normalizePunct_(ch) + " ";
      continue;
    }

    // ASCII punctuation (keep)
    if(/[.,!?;:"'()\[\]{}<>]/.test(ch)){
      out = out.replace(/\s+$/,"");
      out += ch + " ";
      continue;
    }
  }
  return out.trim();
}

function buildScriptOutputs_(lines, map){
  // paired lines .txt, and 2-col TSV
  var txt = [];
  var tsv = [];
  for(var i=0;i<lines.length;i++){
    var raw = String(lines[i]||"");
    var tr = transliterateLine_(raw, map);
    txt.push(raw);
    txt.push(tr);
    txt.push(""); // blank line between
    tsv.push(raw + "\t" + tr);
  }
  return { txt: txt.join("\n"), tsv: tsv.join("\n") };
}

function csvEscape_(v){
  v = String(v==null ? "" : v);
  if(/[",\n\r\t]/.test(v)){
    v = "\"" + v.replace(/"/g,'""') + "\"";
  }
  return v;
}

function downloadBlob_(filename, blob){
  try{
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){
      try{ a.remove(); }catch(_e){}
      try{ URL.revokeObjectURL(url); }catch(_e2){}
    }, 0);
  }catch(e){
    toast("err", "Download failed: " + (e && e.message ? e.message : String(e)));
  }
}

function downloadText_(filename, text){
  var blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  downloadBlob_(filename, blob);
}

function downloadCsv_(filename, headers, rows){
  var out = [];
  out.push(headers.map(csvEscape_).join(","));
  for(var i=0;i<rows.length;i++){
    out.push(rows[i].map(csvEscape_).join(","));
  }
  // UTF-8 BOM for Excel
  var blob = new Blob(["\uFEFF" + out.join("\n")], { type: "text/csv;charset=utf-8" });
  downloadBlob_(filename, blob);
}

function renderScriptUnknowns_(wrapEl, unknownRows){
  if(!wrapEl){ return; }
  if(!unknownRows || !unknownRows.length){
    wrapEl.innerHTML = '<div class="note">No unknown characters 🎉</div>';
    return;
  }
  var html = '';
  html += '<table class="tbl" style="width:100%;">';
  html += '<thead><tr>';
  html += '<th style="width:90px;">Char</th>';
  html += '<th style="width:90px;">Count</th>';
  html += '<th>Token (lowercase)</th>';
  html += '<th style="width:110px;">Status</th>';
  html += '</tr></thead><tbody>';
  for(var i=0;i<unknownRows.length;i++){
    var r = unknownRows[i];
    var ch = r.ch;
    var count = r.count || 0;
    html += '<tr data-ch="'+String(ch).replace(/"/g,'&quot;')+'">';
    html += '<td class="mono" style="font-size:18px;">'+String(ch)+'</td>';
    html += '<td class="mono">'+String(count)+'</td>';
    html += '<td><input class="inp slbSaamlScriptTokInp" placeholder="token" value="'+(r.token?String(r.token).replace(/"/g,'&quot;'):'')+'"></td>';
    html += '<td class="note slbSaamlScriptStat" style="margin:0;">missing</td>';
    html += '</tr>';
  }
  html += '</tbody></table>';
  wrapEl.innerHTML = html;
}

var scriptState = {
  text: "",
  lines: [],
  counts: null,
  map: null,
  missing: [],
  unknownRows: [],
  outTxt: "",
  outTsv: ""
};

function scriptUiSet_(ids, prop, val){
  var el = $(ids);
  if(!el) return;
  if(prop === "text") el.textContent = val;
  else if(prop === "html") el.innerHTML = val;
  else if(prop === "val") el.value = val;
}

function scriptEnable_(id, yes){
  var el = $(id);
  if(el) el.disabled = !yes;
}

function scriptRefreshButtons_(){
  var hasText = !!scriptState.text;
  var hasScan = hasText && scriptState.map;
  var hasUnknown = hasScan && scriptState.unknownRows && scriptState.unknownRows.length;
  var hasOut = !!scriptState.outTxt;

  scriptEnable_("slbSaamlScriptureUnknownCsvBtn", hasUnknown);
  scriptEnable_("slbSaamlScriptureApplyBtn", hasUnknown);
  scriptEnable_("slbSaamlScriptureGenBtn", hasScan);
  scriptEnable_("slbSaamlScriptureTxtBtn", hasOut);
  scriptEnable_("slbSaamlScriptureTsvBtn", hasOut);
}

function scriptUpdateStats_(){
  var el = $("slbSaamlScriptureStats");
  if(!el) return;
  if(!scriptState.text){
    el.textContent = "";
    return;
  }
  var u = scriptState.counts ? (scriptState.counts.chars.length) : 0;
  var miss = scriptState.missing ? scriptState.missing.length : 0;
  el.textContent = "Unique chars: " + u + " | Unknown: " + miss;
}

async function scriptureScan_(){
  adminMsg("", "");
  var ta = $("slbSaamlScriptureIn");
  var text = ta ? String(ta.value||"") : "";
  scriptState.text = text;
  scriptState.lines = text.split(/\r?\n/);
  scriptState.outTxt = "";
  scriptState.outTsv = "";
  scriptUiSet_("slbSaamlScriptureOut", "text", "");
  scriptUiSet_("slbSaamlScripturePasteOut", "text", "");

  if(!text.trim()){
    scriptState.counts = null;
    scriptState.map = null;
    scriptState.missing = [];
    scriptState.unknownRows = [];
    scriptUiSet_("slbSaamlScriptureUnknownWrap", "html", "");
    scriptUpdateStats_();
    scriptRefreshButtons_();
    adminMsg("", "Paste some Chinese text first.");
    return;
  }

  try{
    scriptUiSet_("slbSaamlScriptureStats", "text", "Scanning…");
    var cc = collectCharCounts_(text);
    scriptState.counts = cc;

    if(!cc.chars.length){
      scriptState.map = {};
      scriptState.missing = [];
      scriptState.unknownRows = [];
      scriptUiSet_("slbSaamlScriptureUnknownWrap", "html", '<div class="note">No Chinese characters found.</div>');
      scriptUpdateStats_();
      scriptRefreshButtons_();
      return;
    }

    // sort chars for stable chunking
    cc.chars.sort();
    var look = await lookupCharsMap_(cc.chars);
    scriptState.map = look.map || {};
    scriptState.missing = look.missing || [];

    // build unknown rows sorted by count desc
    var rows = [];
    for(var i=0;i<scriptState.missing.length;i++){
      var ch = scriptState.missing[i];
      rows.push({ ch: ch, count: cc.counts[ch] || 0, token: "" });
    }
    rows.sort(function(a,b){
      return (b.count||0) - (a.count||0);
    });
    scriptState.unknownRows = rows;

    renderScriptUnknowns_($("slbSaamlScriptureUnknownWrap"), rows);
    scriptUpdateStats_();
    scriptRefreshButtons_();
    adminMsg("Scan done.", "");

  }catch(e){
    var m = (e && e.message) ? e.message : String(e||"Error");
    adminMsg("", m);
    toast("err", m);
    scriptUiSet_("slbSaamlScriptureStats", "text", "");
    scriptRefreshButtons_();
  }
}

function scriptCollectTableEdits_(){
  var wrap = $("slbSaamlScriptureUnknownWrap");
  if(!wrap) return [];
  var trs = wrap.querySelectorAll("tbody tr");
  var items = [];
  for(var i=0;i<trs.length;i++){
    var tr = trs[i];
    var ch = String(tr.getAttribute("data-ch")||"");
    if(!ch) continue;
    var inp = tr.querySelector("input.slbSaamlScriptTokInp");
    var tok = inp ? String(inp.value||"").trim().toLowerCase() : "";
    if(!tok) continue;
    items.push([ch, tok]);
  }
  // de-dup keep last
  var seen = Object.create(null);
  var uniq = [];
  for(var j=items.length-1;j>=0;j--){
    var c = items[j][0];
    if(!seen[c]){ seen[c]=1; uniq.push(items[j]); }
  }
  uniq.reverse();
  if(uniq.length > 2000) uniq = uniq.slice(0,2000);
  return uniq;
}

async function scriptureApplyTable_(){
  adminMsg("", "");
  var items = scriptCollectTableEdits_();
  if(!items.length){
    adminMsg("", "No tokens filled.");
    return;
  }
  try{
    scriptUiSet_("slbSaamlScriptureStats", "text", "Saving " + items.length + "…");
    var res = await rpc("adminSaamlCharBulkUpsert", { items: items });
    if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Save failed");
    // merge into map
    scriptState.map = scriptState.map || {};
    for(var i=0;i<items.length;i++){
      scriptState.map[items[i][0]] = items[i][1];
    }
    // remove applied from unknown list
    var applied = Object.create(null);
    for(var j=0;j<items.length;j++) applied[items[j][0]] = 1;
    var nextRows = [];
    for(var k=0;k<scriptState.unknownRows.length;k++){
      if(!applied[scriptState.unknownRows[k].ch]) nextRows.push(scriptState.unknownRows[k]);
    }
    scriptState.unknownRows = nextRows;
    scriptState.missing = nextRows.map(function(r){ return r.ch; });

    renderScriptUnknowns_($("slbSaamlScriptureUnknownWrap"), scriptState.unknownRows);
    scriptUpdateStats_();
    scriptRefreshButtons_();
    scriptUiSet_("slbSaamlScriptureStats", "text", "Saved " + (res.savedCount||0) + " token(s).");
    try{ await adminDiag(); }catch(_e2){}
    adminMsg("Applied tokens.", "");
  }catch(e){
    var m = (e && e.message) ? e.message : String(e||"Error");
    adminMsg("", m);
    toast("err", m);
    scriptUpdateStats_();
    scriptRefreshButtons_();
  }
}

async function scriptureDownloadUnknownCsv_(){
  if(!scriptState.unknownRows || !scriptState.unknownRows.length){
    toast("info", "No unknowns.");
    return;
  }
  var rows = [];
  for(var i=0;i<scriptState.unknownRows.length;i++){
    var r = scriptState.unknownRows[i];
    rows.push([r.ch, String(r.count||0), "", ""]);
  }
  downloadCsv_("saaml_unknowns.csv", ["chinese_char","count","current_mapping","saamlawnese"], rows);
}

function scriptureGenerate_(){
  if(!scriptState.text || !scriptState.map){
    toast("info", "Scan first.");
    return;
  }
  var out = buildScriptOutputs_(scriptState.lines, scriptState.map);
  scriptState.outTxt = out.txt;
  scriptState.outTsv = out.tsv;
  scriptUiSet_("slbSaamlScriptureOut", "text", out.txt);
  scriptRefreshButtons_();
}

async function scriptureApplyPaste_(){
  adminMsg("", "");
  var ta = $("slbSaamlScripturePasteIn");
  var out = $("slbSaamlScripturePasteOut");
  if(out) out.textContent = "";
  var items = parseBulk_(ta ? ta.value : "");
  if(!items.length){
    if(out) out.textContent = "No valid lines.";
    return;
  }
  try{
    if(out) out.textContent = "Saving…";
    var res = await rpc("adminSaamlCharBulkUpsert", { items: items });
    if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Save failed");
    if(out) out.textContent = "Saved " + (res.savedCount||0) + " char(s).";
    // best-effort refresh scan
    try{ await scriptureScan_(); }catch(_e2){}
  }catch(e){
    var m = (e && e.message) ? e.message : String(e||"Error");
    if(out) out.textContent = m;
    toast("err", m);
  }
}

function onScriptTokInput_(e){
  var inp = e.target;
  if(!inp || !inp.classList || !inp.classList.contains("slbSaamlScriptTokInp")) return;
  var tr = inp.closest ? inp.closest("tr") : null;
  if(!tr) return;
  var stat = tr.querySelector(".slbSaamlScriptStat");
  var v = String(inp.value||"").trim();
  if(stat) stat.textContent = v ? "filled" : "missing";
}

// -----------------------
// Meta + Audio (Admin)
// -----------------------
function canonTok_(v){ return String(v||"").trim().toLowerCase(); }

function metaFill_(tok, metaRes, dictRes){
  tok = canonTok_(tok);
  var metaTok = $("slbSaamlMetaToken");
  var metaDisplay = $("slbSaamlMetaDisplay");
  var metaEnglish = $("slbSaamlMetaEnglish");
  var metaTags = $("slbSaamlMetaTags");
  var metaExplain = $("slbSaamlMetaExplain");
  var metaNotes = $("slbSaamlMetaNotes");

  var audioUrlInp = $("slbSaamlAudioUrl");
  var audioMimeInp = $("slbSaamlAudioMime");
  var audioDurInp = $("slbSaamlAudioDuration");
  var recPreview = $("slbSaamlRecPreview");

  if(metaTok) metaTok.value = tok ? (tok.charAt(0).toUpperCase()+tok.slice(1)) : "";
  if(metaDisplay) metaDisplay.value = (metaRes && metaRes.display) ? metaRes.display : ((dictRes && dictRes.display) ? dictRes.display : "");
  if(metaEnglish) metaEnglish.value = (metaRes && metaRes.english) ? metaRes.english : ((dictRes && dictRes.english) ? dictRes.english : "");
  if(metaExplain) metaExplain.value = (metaRes && metaRes.chinese_explain) ? metaRes.chinese_explain : ((dictRes && dictRes.chinese_explain) ? dictRes.chinese_explain : "");
  if(metaTags) metaTags.value = (metaRes && metaRes.tags) ? metaRes.tags : ((dictRes && dictRes.tags) ? dictRes.tags : "");
  if(metaNotes) metaNotes.value = (metaRes && metaRes.notes_internal) ? metaRes.notes_internal : "";

  if(audioUrlInp) audioUrlInp.value = (dictRes && dictRes.audioUrl) ? dictRes.audioUrl : "";
  if(audioMimeInp) audioMimeInp.value = (dictRes && dictRes.audioMime) ? dictRes.audioMime : "";
  if(audioDurInp) audioDurInp.value = (dictRes && dictRes.audioDurationMs) ? String(dictRes.audioDurationMs||"") : "";

  if(recPreview && dictRes && dictRes.audioUrl){
    try{ recPreview.src = dictRes.audioUrl; }catch(_e){}
  }
}

async function metaLoad_(){
  var metaTok = $("slbSaamlMetaToken");
  var tok = canonTok_(metaTok ? metaTok.value : "");
  if(!tok){ alert("Enter a token first."); return; }
  adminMsg("", "");
  try{
    var metaRes = await rpc("adminSaamlTokenMetaGet", { token: tok });
    var dictRes = await rpc("saamlDictGetToken", { token: tok });
    if(!metaRes || !metaRes.ok) throw new Error((metaRes && (metaRes.err||metaRes.error)) || "Meta load failed");
    if(!dictRes || !dictRes.ok) throw new Error((dictRes && (dictRes.err||dictRes.error)) || "Dict load failed");
    metaFill_(tok, metaRes, dictRes);
    adminMsg("Loaded.", "");
  }catch(e){
    adminMsg("", String(e && e.message ? e.message : e));
  }
}

async function metaSave_(){
  var metaTok = $("slbSaamlMetaToken");
  var tok = canonTok_(metaTok ? metaTok.value : "");
  if(!tok){ alert("Enter a token first."); return; }
  var metaDisplay = $("slbSaamlMetaDisplay");
  var metaEnglish = $("slbSaamlMetaEnglish");
  var metaTags = $("slbSaamlMetaTags");
  var metaExplain = $("slbSaamlMetaExplain");
  var metaNotes = $("slbSaamlMetaNotes");

  adminMsg("", "");
  try{
    var res = await rpc("adminSaamlTokenMetaUpsert", {
      token: tok,
      display: metaDisplay ? metaDisplay.value : "",
      english: metaEnglish ? metaEnglish.value : "",
      chinese_explain: metaExplain ? metaExplain.value : "",
      tags: metaTags ? metaTags.value : "",
      notes_internal: metaNotes ? metaNotes.value : ""
    });
    if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Save failed");
    await metaLoad_();
    try{ await adminDiag(); }catch(_e2){}
    adminMsg("Saved meta.", "");
  }catch(e){
    adminMsg("", String(e && e.message ? e.message : e));
  }
}

async function audioSave_(){
  var metaTok = $("slbSaamlMetaToken");
  var tok = canonTok_(metaTok ? metaTok.value : "");
  if(!tok){ alert("Enter a token first."); return; }
  var audioUrlInp = $("slbSaamlAudioUrl");
  var audioMimeInp = $("slbSaamlAudioMime");
  var audioDurInp = $("slbSaamlAudioDuration");
  var url = String(audioUrlInp ? audioUrlInp.value : "").trim();
  if(!url){ alert("Paste the audio URL first."); return; }
  adminMsg("", "");
  try{
    var res = await rpc("adminSaamlAudioUpsert", {
      token: tok,
      url: url,
      mime: audioMimeInp ? audioMimeInp.value : "",
      durationMs: audioDurInp ? audioDurInp.value : ""
    });
    if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Save failed");
    await metaLoad_();
    try{ await adminDiag(); }catch(_e2){}
    adminMsg("Saved audio link.", "");
  }catch(e){
    adminMsg("", String(e && e.message ? e.message : e));
  }
}

async function audioDelete_(){
  var metaTok = $("slbSaamlMetaToken");
  var tok = canonTok_(metaTok ? metaTok.value : "");
  if(!tok){ alert("Enter a token first."); return; }
  if(!confirm("Delete this token's audio link?")) return;
  var audioUrlInp = $("slbSaamlAudioUrl");
  var audioMimeInp = $("slbSaamlAudioMime");
  var audioDurInp = $("slbSaamlAudioDuration");
  var recPreview = $("slbSaamlRecPreview");

  adminMsg("", "");
  try{
    var res = await rpc("adminSaamlAudioDelete", { token: tok });
    if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Delete failed");
    if(audioUrlInp) audioUrlInp.value = "";
    if(audioMimeInp) audioMimeInp.value = "";
    if(audioDurInp) audioDurInp.value = "";
    if(recPreview) recPreview.removeAttribute("src");
    try{ await adminDiag(); }catch(_e2){}
    adminMsg("Deleted audio link.", "");
  }catch(e){
    adminMsg("", String(e && e.message ? e.message : e));
  }
}


async function blobToDataUrl_(blob){
  return await new Promise(function(resolve, reject){
    try{
      var fr = new FileReader();
      fr.onload = function(){ resolve(String(fr.result||"")); };
      fr.onerror = function(){ reject(new Error("File read failed")); };
      fr.readAsDataURL(blob);
    }catch(e){ reject(e); }
  });
}

async function audioUpload_(blob){
  var metaTok = $("slbSaamlMetaToken");
  var tok = canonTok_(metaTok ? metaTok.value : "");
  if(!tok){ alert("Enter a token first."); return; }

  var audioUrlInp = $("slbSaamlAudioUrl");
  var audioMimeInp = $("slbSaamlAudioMime");
  var audioDurInp  = $("slbSaamlAudioDuration");
  var recPreview   = $("slbSaamlRecPreview");

  if(!blob){ alert("No audio to upload."); return; }

  adminMsg("", "");
  try{
    var dataUrl = await blobToDataUrl_(blob);

    var mime = (audioMimeInp && audioMimeInp.value) ? audioMimeInp.value : (blob.type || "");
    var durMs = (audioDurInp && audioDurInp.value) ? audioDurInp.value : "";

    var res = await rpc("adminSaamlAudioUpload", {
      token: tok,
      audioDataUrl: dataUrl,
      mime: mime,
      durationMs: durMs
    }, { progressLabel: "Uploading audio..." });

    if(!res || !res.ok) throw new Error((res && (res.err||res.error)) || "Upload failed");

    if(audioUrlInp) audioUrlInp.value = res.audioUrl || "";
    if(audioMimeInp) audioMimeInp.value = res.mime || mime || "";
    if(audioDurInp && res.durationMs != null) audioDurInp.value = String(res.durationMs||"");

    // preview from server URL (not objectURL)
    if(recPreview && res.audioUrl){
      try{ recPreview.src = res.audioUrl; }catch(_e){}
    }

    await metaLoad_();
    try{ await adminDiag(); }catch(_e2){}
    adminMsg("Uploaded audio to Drive and saved.", "");
  }catch(e){
    adminMsg("", String(e && e.message ? e.message : e));
  }
}

async function audioUploadRecorded_(){
  if(!recState || !recState.blob){ alert("Record a clip first."); return; }
  await audioUpload_(recState.blob);
}

async function audioUploadSelectedFile_(){
  var inp = $("slbSaamlAudioFile");
  var f = inp && inp.files && inp.files[0];
  if(!f){ alert("Choose an audio file first."); return; }
  await audioUpload_(f);
}

// Recorder (client-side only)
var recState = { mr:null, stream:null, blob:null, objUrl:"" };

function recMimePick_(){
  try{
    if(window.MediaRecorder && MediaRecorder.isTypeSupported){
      if(MediaRecorder.isTypeSupported("audio/webm;codecs=opus")) return "audio/webm;codecs=opus";
      if(MediaRecorder.isTypeSupported("audio/webm")) return "audio/webm";
      if(MediaRecorder.isTypeSupported("audio/mp4")) return "audio/mp4";
    }
  }catch(_e){}
  return "";
}

async function recStart_(){
  var recPreview = $("slbSaamlRecPreview");
  var recStartBtn = $("slbSaamlRecStartBtn");
  var recStopBtn  = $("slbSaamlRecStopBtn");
  var recDlBtn    = $("slbSaamlRecDownloadBtn");
  var audioMimeInp = $("slbSaamlAudioMime");
  var audioDurInp  = $("slbSaamlAudioDuration");

  if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia){
    alert("Recording not supported on this browser.");
    return;
  }
  try{
    adminMsg("", "");
    if(recState.objUrl){
      try{ URL.revokeObjectURL(recState.objUrl); }catch(_e){}
      recState.objUrl = "";
    }
    recState.blob = null;
    try{ var up = $("slbSaamlAudioUploadRecBtn"); if(up) up.disabled = true; }catch(_eA){}

    var stream = await navigator.mediaDevices.getUserMedia({ audio:true });
    recState.stream = stream;

    var mime = recMimePick_();
    var mr = mime ? new MediaRecorder(stream, { mimeType:mime }) : new MediaRecorder(stream);
    recState.mr = mr;

    var chunks = [];
    mr.ondataavailable = function(e){ if(e.data && e.data.size) chunks.push(e.data); };
    mr.onstop = function(){
      try{ stream.getTracks().forEach(function(t){ t.stop(); }); }catch(_e2){}
      recState.stream = null;
      recState.blob = new Blob(chunks, { type: mr.mimeType || mime || "audio/webm" });
      recState.objUrl = URL.createObjectURL(recState.blob);
      if(recPreview) recPreview.src = recState.objUrl;
      if(recDlBtn) recDlBtn.disabled = false;
      try{ var up = $("slbSaamlAudioUploadRecBtn"); if(up) up.disabled = false; }catch(_eU){}
      if(audioMimeInp && !audioMimeInp.value) audioMimeInp.value = recState.blob.type || (mr.mimeType||"");
      if(recPreview){
        recPreview.onloadedmetadata = function(){
          try{
            var ms = Math.round((recPreview.duration||0)*1000);
            if(ms && audioDurInp) audioDurInp.value = String(ms);
          }catch(_e3){}
        };
      }
    };

    mr.start();

    if(recStartBtn) recStartBtn.disabled = true;
    if(recStopBtn) recStopBtn.disabled = false;
    if(recDlBtn) recDlBtn.disabled = true;
  }catch(e){
    adminMsg("", String(e && e.message ? e.message : e));
    try{ if(recState.stream) recState.stream.getTracks().forEach(function(t){ t.stop(); }); }catch(_e4){}
    recState.stream = null;
  }
}

function recStop_(){
  var recStartBtn = $("slbSaamlRecStartBtn");
  var recStopBtn  = $("slbSaamlRecStopBtn");
  try{ if(recState.mr && recState.mr.state !== "inactive") recState.mr.stop(); }catch(_e){}
  if(recStartBtn) recStartBtn.disabled = false;
  if(recStopBtn) recStopBtn.disabled = true;
}

function recDownload_(){
  if(!recState.blob || !recState.objUrl) return;
  var metaTok = $("slbSaamlMetaToken");
  var tok = canonTok_(metaTok ? metaTok.value : "") || "token";
  var mime = recState.blob.type || "audio/webm";
  var ext = (mime.indexOf("mp4") >= 0) ? "mp4" : "webm";
  var a = document.createElement("a");
  a.href = recState.objUrl;
  a.download = "saaml_" + tok + "." + ext;
  document.body.appendChild(a);
  a.click();
  setTimeout(function(){ try{ a.remove(); }catch(_e){} }, 0);
}

// -----------------------
// Admin init
// -----------------------
function initAdmin(){
  if(adminBooted) return;
  adminBooted = true;

  // Tabs
  var tMaster = $("slbSaamlAdminTabMaster");
  var tCorr   = $("slbSaamlAdminTabCorrections");
  var tMeta   = $("slbSaamlAdminTabMetaAudio");
  var tScr    = $("slbSaamlAdminTabScripture");

  if(tMaster) tMaster.addEventListener("click", function(){ adminSetTab("master"); });
  if(tCorr)   tCorr.addEventListener("click", function(){ adminSetTab("corrections"); });
  if(tMeta)   tMeta.addEventListener("click", function(){ adminSetTab("meta_audio"); });
  if(tScr)    tScr.addEventListener("click", function(){ adminSetTab("scripture"); });

  // Master controls
  var initBtn = $("slbSaamlInitBtn");
  var diagBtn = $("slbSaamlDiagBtn");
  var upBtn   = $("slbSaamlUpsertBtn");
  var bulkBtn = $("slbSaamlBulkApplyBtn");
  var bulkClr = $("slbSaamlBulkClearBtn");
  var tokBtn  = $("slbSaamlTokLookupBtn");
  var charBtn = $("slbSaamlCharLookupBtn");

  if(initBtn) initBtn.addEventListener("click", adminInit);
  if(diagBtn) diagBtn.addEventListener("click", adminDiag);
  if(upBtn)   upBtn.addEventListener("click", adminUpsert);
  if(bulkBtn) bulkBtn.addEventListener("click", adminBulkApply);
  if(bulkClr) bulkClr.addEventListener("click", function(){
    var ta = $("slbSaamlBulkText"); if(ta) ta.value = "";
    var out = $("slbSaamlBulkOut"); if(out) out.textContent = "";
  });
  if(tokBtn)  tokBtn.addEventListener("click", adminLookupToken);
  if(charBtn) charBtn.addEventListener("click", adminLookupChar);

  // Import MASTER.csv
  var impBtn = $("slbSaamlImportBtn");
  var impClrBtn = $("slbSaamlImportClearBtn");
  if(impBtn) impBtn.addEventListener("click", adminImportMasterCsv);
  if(impClrBtn) impClrBtn.addEventListener("click", function(){
    var f = $("slbSaamlImportFile"); if(f) f.value = "";
    var o = $("slbSaamlImportOut"); if(o) o.textContent = "";
  });

  // Maintenance / Backup
  var newDbBtn = $("slbSaamlCreateNewDbBtn");
  var rebIdxBtn = $("slbSaamlRebuildIndexBtn");
  var exMasterCsv = $("slbSaamlExportMasterCsvBtn");
  var exMasterJson = $("slbSaamlExportMasterJsonBtn");
  var exMetaCsv = $("slbSaamlExportMetaCsvBtn");
  var exAudioCsv = $("slbSaamlExportAudioCsvBtn");
  var exIndexCsv = $("slbSaamlExportIndexCsvBtn");
  if(newDbBtn) newDbBtn.addEventListener("click", maintCreateNewDb);
  if(rebIdxBtn) rebIdxBtn.addEventListener("click", maintRebuildIndex);
  if(exMasterCsv) exMasterCsv.addEventListener("click", function(){ exportSheetCsv_("adminSaamlExportMasterPage", "saamlawnese_master.csv"); });
  if(exMasterJson) exMasterJson.addEventListener("click", exportMasterJson_);
  if(exMetaCsv) exMetaCsv.addEventListener("click", function(){ exportSheetCsv_("adminSaamlExportTokenMetaPage", "saamlawnese_token_meta.csv"); });
  if(exAudioCsv) exAudioCsv.addEventListener("click", function(){ exportSheetCsv_("adminSaamlExportAudioPage", "saamlawnese_audio.csv"); });
  if(exIndexCsv) exIndexCsv.addEventListener("click", function(){ exportSheetCsv_("adminSaamlExportTokenIndexPage", "saamlawnese_token_index.csv"); });

  // Corrections
  var anaBtn = $("slbSaamlCorrAnalyzeBtn");
  var appBtn = $("slbSaamlCorrApplyBtn");
  if(anaBtn) anaBtn.addEventListener("click", correctionsAnalyze);
  if(appBtn) appBtn.addEventListener("click", correctionsApply);
  var corrWrap = $("slbSaamlCorrTableWrap");
  if(corrWrap) corrWrap.addEventListener("input", onCorrectionsInput_);

  // Meta + Audio
  var metaLoadBtn = $("slbSaamlMetaLoadBtn");
  var metaSaveBtn = $("slbSaamlMetaSaveBtn");
  var audioSaveBtn = $("slbSaamlAudioSaveBtn");
  var audioDeleteBtn = $("slbSaamlAudioDeleteBtn");

  if(metaLoadBtn) metaLoadBtn.addEventListener("click", metaLoad_);
  if(metaSaveBtn) metaSaveBtn.addEventListener("click", metaSave_);
  if(audioSaveBtn) audioSaveBtn.addEventListener("click", audioSave_);
  if(audioDeleteBtn) audioDeleteBtn.addEventListener("click", audioDelete_);

  // Recorder
  var recStartBtn = $("slbSaamlRecStartBtn");
  var recStopBtn  = $("slbSaamlRecStopBtn");
  var recDlBtn    = $("slbSaamlRecDownloadBtn");
  if(recStartBtn) recStartBtn.addEventListener("click", recStart_);
  if(recStopBtn)  recStopBtn.addEventListener("click", recStop_);
  if(recDlBtn)    recDlBtn.addEventListener("click", recDownload_);

  // Audio upload
  var audioFileInp = $("slbSaamlAudioFile");
  var uploadRecBtn = $("slbSaamlAudioUploadRecBtn");
  var uploadFileBtn = $("slbSaamlAudioUploadFileBtn");
  if(uploadRecBtn) uploadRecBtn.addEventListener("click", audioUploadRecorded_);
  if(uploadFileBtn) uploadFileBtn.addEventListener("click", audioUploadSelectedFile_);
  if(audioFileInp) audioFileInp.addEventListener("change", function(){
    try{
      var f = audioFileInp.files && audioFileInp.files[0];
      if(uploadFileBtn) uploadFileBtn.disabled = !f;
    }catch(_e){}
  });

  // Scripture tool
  var scanBtn = $("slbSaamlScriptureScanBtn");
  var applyBtn = $("slbSaamlScriptureApplyBtn");
  var csvBtn = $("slbSaamlScriptureUnknownCsvBtn");
  var genBtn = $("slbSaamlScriptureGenBtn");
  var txtBtn = $("slbSaamlScriptureTxtBtn");
  var tsvBtn = $("slbSaamlScriptureTsvBtn");
  var pasteApplyBtn = $("slbSaamlScripturePasteApplyBtn");

  if(scanBtn) scanBtn.addEventListener("click", scriptureScan_);
  if(applyBtn) applyBtn.addEventListener("click", scriptureApplyTable_);
  if(csvBtn) csvBtn.addEventListener("click", scriptureDownloadUnknownCsv_);
  if(genBtn) genBtn.addEventListener("click", scriptureGenerate_);
  if(txtBtn) txtBtn.addEventListener("click", function(){
    if(!scriptState.outTxt) return;
    downloadText_("saaml_transliteration.txt", scriptState.outTxt);
  });
  if(tsvBtn) tsvBtn.addEventListener("click", function(){
    if(!scriptState.outTsv) return;
    downloadText_("saaml_transliteration.tsv", scriptState.outTsv);
  });
  if(pasteApplyBtn) pasteApplyBtn.addEventListener("click", scriptureApplyPaste_);

  var unkWrap = $("slbSaamlScriptureUnknownWrap");
  if(unkWrap) unkWrap.addEventListener("input", onScriptTokInput_);

  // Default view
  adminSetTab("master");
  try{ adminDiag(); }catch(_e){}
  scriptRefreshButtons_();
  scriptUpdateStats_();
}



  // -----------------------
  // Hook into tab open
  // -----------------------
  function hookOnOpen(){
    window.SLB = window.SLB || {};
    window.SLB.features = window.SLB.features || {};
    var prev = window.SLB.features.onOpen;
    if(prev && prev.__saamlWrapped__) return;

    var wrapped = function(tab, ctx){
      try{ if(typeof prev === "function") prev(tab, ctx); }catch(_e){}
      try{
        if(tab === "saamlDict") initDict();
        if(tab === "saamlTools") initAdmin();
      }catch(_e2){}
    };
    wrapped.__saamlWrapped__ = true;
    window.SLB.features.onOpen = wrapped;
  }

  hookOnOpen();
})();

